import React from 'react'
import {NavLink} from 'react-router-dom'

import styled from 'styled-components'
import Brightness from '../scripts/Brightness'

import SiteIcons from '../assets/SiteIcons'

const CourseGrid = (props) => {

  let bgImageStyle

  if (props.courseImg !== undefined) {
    bgImageStyle = {
      backgroundImage: 'url(https://assets.lmscourses.com/lesson-screenshots/' + props.courseImg + ')'
    }
  }

  const AddToReport = props.courseLanguages.split('|')
  const Languages = ['En']

  if (AddToReport.includes('Spanish')) {
    Languages.push('És')
  }

  if (AddToReport.includes('French')) {
    Languages.push('Fr')
  }

  const TextAndSVGColor = Brightness(props.themeStyles.background, .3)

  const DetailsStyles = styled.div`
    color: ${TextAndSVGColor};

    .duration, .languages {

      .icon {
        #accent {
          stroke: ${TextAndSVGColor};
        }

        #lines {
          stroke: ${TextAndSVGColor};
        }

        #fill {
          fill: none;
        }
      }

    }
  `

  return (

    <div className="courseContainer">
      <div className="course">
        <NavLink className="courseLink" to={'/courses/' + props.courseCategory + '/' + props.id}>
          <div className="thumbContainer">
            <div className="courseThumbArea" style={bgImageStyle}></div>
          </div>
          <div className="courseDetails">
            <h1>{props.courseName}</h1>
            <DetailsStyles className="details">
              <span className="duration"><SiteIcons icon="time" />
                <span>{props.courseHours}:{props.courseMins}</span>
              </span>
              <span className="languages"><SiteIcons icon="languages" /> {Languages.map((lan, idx) => {

                  let langComma = ''
                  let langLength = Languages.length - 1;

                  let langText = ''

                  switch(lan) {
                    case 'En':
                      langText = 'English'
                      break

                    case 'És':
                      langText = 'Spanish'
                      break

                    case 'Fr':
                      langText = 'French'
                      break

                  }

                  if (idx !== langLength) {
                    langComma = ','
                  }

                  return <span key={idx}>{langText}{langComma}</span>
                })}
              </span>
            </DetailsStyles>
          </div>
        </NavLink>
      </div>
    </div>

  )

}

export default CourseGrid
